<template>
  <div class="agreement_index">
    <div v-html="content"></div>
  </div>  
</template>

<script>
export default {
  data(){
    return {
      content:''
    }
  },
  created(){
    let parme = this.$route.query;
    let url = 'sys/base/sys_var/beesAgreement'
    if(parme.type == 'user'){
      url= 'sys/base/sys_var/agreement'
    }
    this.getAgreement(url)
  },
  methods:{
    async getAgreement(url){
      let data = await this.http({ methods:'get',url:url})
      if(data.code ==200){
        this.$loading.hide();
        this.content = data.data;
      }
    
    }
  }
}
</script>

<style lang="less" scoped>
  .agreement_index{
    padding: 0 20px;
  }
</style>

